module.exports = __webpack_public_path__ + "static/media/dot.5bdd976e.svg";